import type { Locale } from "@holigral/shared/i18n"
import type {
  ChangeEmailPayload,
  GetUsersFilter,
  MeUser,
  ProfilePayload,
} from "./model"
import { baseApi } from "@/base"
import type { User } from "@/auth"

const api = baseApi.injectEndpoints({
  endpoints: (build) => ({
    getMe: build.query<MeUser, void>({
      query: () => "users/me",
    }),
    getUsers: build.query<User[], GetUsersFilter>({
      query: (params) => ({ url: "users", params }),
    }),
    changeEmail: build.mutation<MeUser, ChangeEmailPayload>({
      query: (body) => ({
        url: "email",
        method: "POST",
        body,
      }),
      async onQueryStarted(_args, { dispatch, queryFulfilled }) {
        try {
          const { data: me } = await queryFulfilled

          await dispatch(api.util.upsertQueryData("getMe", undefined, me))
        } catch {
          // noop
        }
      },
    }),
    updateProfile: build.mutation<MeUser, ProfilePayload>({
      query: (body) => ({
        url: "users/me",
        method: "PATCH",
        body,
      }),
      async onQueryStarted(_args, { dispatch, queryFulfilled }) {
        try {
          const { data: me } = await queryFulfilled

          await dispatch(api.util.upsertQueryData("getMe", undefined, me))
        } catch {
          // noop
        }
      },
    }),
    updateLocale: build.mutation<MeUser, { locale: Locale }>({
      query: (body) => ({
        url: "users/me/locale",
        method: "PATCH",
        body,
      }),
      async onQueryStarted(_args, { dispatch, queryFulfilled }) {
        try {
          const { data: me } = await queryFulfilled

          await dispatch(api.util.upsertQueryData("getMe", undefined, me))
        } catch {
          // noop
        }
      },
    }),
  }),
})

export const {
  useGetMeQuery,
  useGetUsersQuery,
  useChangeEmailMutation,
  useUpdateProfileMutation,
  useUpdateLocaleMutation,
} = api
